import { CommerceProperty, SimpleProduct } from '~/interfaces/simple-product';
import { addCartLines } from '~/services/actions/CSU/add-cart-lines';
import { updateCart } from '~/services/actions/CSU/update-cart';
import { getDeliveryServiceWithSKU } from '~/utils/get-delivery-service';
import { ISalesOrderResponse } from '~/interfaces/get-sales-order';
import {
  DONATION_DELIVERY_PRODUCT_TYPE,
  DONATION_SEGMENT,
} from '~/constant/constants';
import { MfrmDeliveryService } from '~/gql/__generated__/types';
import { getCartShippingAddress } from '~/utils/checkout/extract-attribute-values';

async function createVirtualCart(
  getOrderDetails: ISalesOrderResponse,
  cartId: string,
  mfrmDeliveryService: MfrmDeliveryService,
): Promise<void> {
  try {
    const extensionProperty = getCartExtensionProperties(getOrderDetails);
    const getShippingAddress = getCartShippingAddress(getOrderDetails);

    const products = extractCartProducts(getOrderDetails, mfrmDeliveryService);
    const getProducts = products?.map((product) => product.product);
    const cartLines = getProducts?.map((productList) => {
      return {
        ItemId: productList.ItemId,
        ProductId: productList.RecordId,
        Quantity: Math.abs(productList.Quantity ?? 0),
        isPriceKeyedIn: productList.isPriceKeyedIn,
      };
    });
    if (cartLines && cartLines?.length) {
      const addCartLinesResponse = await addCartLines(
        { cartLines: cartLines },
        cartId,
      );

      const updateCartData = {
        ...addCartLinesResponse,
        ExtensionProperties: extensionProperty,
        ShippingAddress: getShippingAddress,
      };

      await updateCart(updateCartData, cartId);
    } else {
      console.log('No Cart Lines to add.');
    }
  } catch (error) {
    console.error('Error in createVirtualCart:', error);
  }
}

const extractCartProducts = (
  getOrderDetails: ISalesOrderResponse,
  mfrmDeliveryService: MfrmDeliveryService,
) => {
  let items;
  const itemIds: string[] | undefined = [];

  const productList = getOrderDetails.ProductList;
  if (productList.length) {
    const getServiceSKU = getDeliveryServiceWithSKU(mfrmDeliveryService);

    items = productList?.map((item) => {
      itemIds?.push(item.ItemId);
      const getServiceData = getServiceSKU?.find((configItem) => {
        return configItem.serviceProductRecId === item.ProductRecordId;
      });
      const simpleProduct: SimpleProduct = {
        ItemId: item.ItemId,
        Description: item.Description,
        RecordId: Number(item.ProductRecordId),
        Price: Number(item.Price),
        DefaultUnitOfMeasure: 'EA',
        IsGiftCard: false,
        ProductTypeValue: Number(item.ProductType),
        BasePrice: Number(item.Price),
        AdjustedPrice: Number(item.NetAmount),
        Quantity: item.Qty,
      };
      if (
        getServiceData?.addKeyInPrice ||
        (item.Segment?.toLowerCase() === DONATION_SEGMENT &&
          item.ProductType === DONATION_DELIVERY_PRODUCT_TYPE)
      ) {
        return {
          product: { ...simpleProduct, isPriceKeyedIn: true },
          count: 1,
        };
      } else {
        return {
          product: simpleProduct,
          count: 1,
        };
      }
    });
  }
  return items;
};

const getCartExtensionProperties = (
  getOrderDetails: ISalesOrderResponse,
): CommerceProperty[] => {
  const extensionProperites: CommerceProperty[] = [];
  if (getOrderDetails && getOrderDetails?.ProductList) {
    const vtexFeeAmount = {
      Key: 'VTXFeeAmount',
      Value: {
        BooleanValue: undefined,
        ByteValue: undefined,
        DateTimeOffsetValue: undefined,
        DecimalValue: Number(getOrderDetails?.TotalRecyclingFee),
        IntegerValue: undefined,
        LongValue: undefined,
        StringValue: undefined,
      },
    };
    extensionProperites.push(vtexFeeAmount);
  }
  return extensionProperites;
};

export default createVirtualCart;
